import {animate, style, transition, trigger} from '@angular/animations';
import {Component, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {PanelOutputGroup} from '../../../core/models/panel-output-group';
import {PanelOutput} from '../../../core/models/panel-output.interface';
import {LoadUserPanelOutputs, SearchUserPanelOutputs} from '../../../core/store/panel-outputs/panel-outputs.actions';
import {PanelOutputsStateSelectors} from '../../../core/store/panel-outputs/panel-outputs.selectors';

@Component({
  selector: 'app-outputs-shell',
  templateUrl: './panel-outputs-shell.component.html',
  styleUrls: ['./panel-outputs-shell.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [style({width: '0px'}), animate('125ms', style({width: '*'}))]),
      transition(':leave', [style({width: '*'}), animate('125ms', style({width: '0px'}))])
    ])]
})
export class PanelOutputsShellComponent implements OnInit {
  @Select(PanelOutputsStateSelectors.userPanelOutputs) devices$: Observable<PanelOutput[]>;
  @Select(PanelOutputsStateSelectors.selectedOutput) selectedOutput$: Observable<PanelOutput>;
  @Select(PanelOutputsStateSelectors.selectedGroup) selectedGroup$: Observable<PanelOutputGroup>;

  isGroupDisplay = true;

  constructor(private readonly store: Store) {
  }

  ngOnInit() {
    this.store.dispatch(new LoadUserPanelOutputs());
  }

  searchDevices(searchTerm: string) {
    this.store.dispatch(new SearchUserPanelOutputs(searchTerm));
  }
}
